import { put } from "redux-saga/effects";
import { authenticate } from "auth/actions";
import { paymentArrangementRequest } from "app/routes";

export function* paymentArrangementRequestNavigate() {
  yield put(authenticate(paymentArrangementRequest()));
}
